import { ActionTree } from 'vuex'

import { AppState } from './types'
import { RootState } from '../types'

const actions: ActionTree<AppState, RootState> = {}

export default actions
